<template>
  <div class='h-topo-treebox'>
    <div class="h-toolbarBg">
      <div class='h-track-listSearchPadding h-inputBox-refresh'>
        <ejs-textbox :placeholder='SearchHoder' v-model='keywords' @keydown.native.enter='neSearch'>
          <span class='icon hero-icon hero-icon-search'></span>
        </ejs-textbox>
      </div>
      <div v-if='true'><button class="h-btn-refresh e-btn e-tbar-btn icon hero-icon hero-icon-refresh" :title='$t("Topo.topoRerefresh")' @click='buttonClk()'/></div>
    </div>
    <div class='h-topo-tree'>
      <ejs-listview ref='listview' :dataSource='datas' :fields='neFieldModel' @select='neChange'></ejs-listview>
    </div>
  </div>
</template>
<script>
import bus from './bus.js';

export default {
  name: 'left-panel',
  data() {
    return {
      keywords: '',
      SearchHoder: this.$t('Topo.topoSearchEquipment'),
      datas: [],
      primaryDatas: [],
      neFieldModel: {
        text: 'name',
        tooltip: 'name',
        id: 'id'
      }
    };
  },
  created() {
    this.getNeListData();
  },
  methods: {
    getNeListData() {
      const $this = this;
      $this.$axios.get('/lte/ems/auth/findNodeIdByAuth').then((response) => {
        if (response && response.status === 200 && response.data.length > 0) {
          const set = new Set(response.data);
          $this.$axios.get('/lte/ems/rack/queryEquipmentList').then((response) => {
            const infoData = response.data.resultVal;
            const arr = [];
            infoData.forEach(data => {
              if (set.has(data.id)) {
                arr.push(data);
              }
            });
            $this.datas = arr;
            $this.primaryDatas = arr;
            console.log($this.datas);
          });
        }
      });
    },
    buttonClk() {
      this.keywords = '';
      bus.$emit('loadRackDiagrams', null);
      this.getNeListData();
    },
    neSearch() {
      if (this.keywords === '') {
        this.datas = this.primaryDatas;
      } else {
        const filterDatas = this.primaryDatas.filter(data => (data.name.includes(this.keywords)));
        this.datas = filterDatas;
      }
      this.$refs.listview.ej2Instances.selectItem(null);
    },
    neChange(args) {
      console.log('+++++++++++++change+++++++++++++++', args);
      if (args && args.data) {
        bus.$emit('loadRackDiagrams', args.data);
      }
    }
  }
};
</script>
